import { IAppointmentsReport } from '../../../interface/IAppointmentsReport'

export const labelSwitch = (
    appointmentStats: IAppointmentsReport[],
    dayLabels: string[],
    monthLabels: string[],
    weekString: string
): string[] => {
    switch (appointmentStats.length) {
        case 7:
            return dayLabels
        case 4:
            return appointmentStats.map(
                (week) => `${weekString} ${week.groupByNumber}`
            )
        case 12:
            return monthLabels
    }
}
